import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  checkCustomPackage,
  getCustomPackagePrice,
  getTotalPricePackage,
} from '@src/services/package';
import {
  checkVoucherPriceOrPercent,
  getOptimalVouchersForPackage,
  getPriceFromVoucher,
} from '@src/services/voucher';
import moment from 'moment';
import { PACKAGE_LEVEL } from '@src/constants/package';
import { checkVietNam } from '../../../utils/checkCountry';
import PackageHeader from '../components/PackageHeader';
import { CurrencySign, PackageContainer, PriceText } from './index.style';
import ButtonBuyPackage from './ButtonBuyPackage';

const VND_SIGN = 'đ';
const USD_SIGN = '$';

const Package = ({ data, packages, totalVoucher, isMobile }) => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const isVietNam = checkVietNam();

  const { startAt, endAt } = data.discountConfig || {};
  const isDiscountPackage = startAt && moment().isBetween(startAt, endAt);
  const vouchers = getOptimalVouchersForPackage({
    pkg: data,
    vouchers: totalVoucher,
  });
  const [bestVoucher] = vouchers || [];
  const isBestVoucherPriceOrPercent = checkVoucherPriceOrPercent(bestVoucher);
  const bestVoucherPriceOrPercent = isBestVoucherPriceOrPercent
    ? bestVoucher
    : null;

  const pricePackageSub = getTotalPricePackage(
    data,
    isDiscountPackage,
    bestVoucherPriceOrPercent,
    isVietNam,
    true,
  );

  const optionsSelected = useSelector(
    (state) => state.packages.optionsSelected,
  );

  // Custom package
  const isCustomPackage = checkCustomPackage({
    type: data?.type,
    level: data?.level,
  });
  const { price: priceVipPlusPackagePrice, vndPrice } = getCustomPackagePrice({
    credits: optionsSelected?.credits,
    voiceClonings: optionsSelected?.voiceClonings,
    devices: optionsSelected?.devices,
    concurrentRequestApi: optionsSelected?.concurrentRequestApi,
    customResource: data?.customResource,
    isVietNam,
  });

  const [bestVoucherCustomPackage] = getOptimalVouchersForPackage({
    pkg: {
      ...data,
      price: priceVipPlusPackagePrice,
      vndPrice,
      usdPrice: priceVipPlusPackagePrice,
      custom: { credits: optionsSelected?.credits },
    },
    vouchers: totalVoucher,
  });

  // Price custom package
  const priceVipPlusPackage = () => {
    const priceWithSaleOff = getPriceFromVoucher({
      isVietNam,
      voucher: bestVoucherCustomPackage,
      currPrice: priceVipPlusPackagePrice,
      currUsdPrice: priceVipPlusPackagePrice,
      roundedPrice: true,
    });
    let value;
    value = priceWithSaleOff?.toLocaleString(language);

    if (!isVietNam && value !== '0') {
      value = value.toLocaleString(language, { minimumFractionDigits: 2 });
    }
    return value;
  };

  // Price package
  const pricePackage = () => {
    if (isCustomPackage) {
      return priceVipPlusPackage();
    }

    return pricePackageSub?.toLocaleString(language);
  };

  return (
    <PackageContainer level={data.level}>
      <PackageHeader data={data} hideDescription comparisonMode />
      <PriceText
        isVipPkg={[PACKAGE_LEVEL.VIP, PACKAGE_LEVEL.CUSTOM].includes(
          data.level,
        )}
      >
        <CurrencySign $isVietNam={isVietNam}>
          {isVietNam ? VND_SIGN : USD_SIGN}
        </CurrencySign>
        {pricePackage()}
      </PriceText>
      {!isMobile && <ButtonBuyPackage data={data} packages={packages} />}
    </PackageContainer>
  );
};

export default Package;
